// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navic_navbar__38ELB","circles":"Navic_circles__3Xjmo","menuBarItems":"Navic_menuBarItems__fiGnK"};